import React from "react";
import styles from "./Loader.module.css";

export default function CudyLoader() {
	return (
		<img
			className={styles.loader}
			width="30"
			height="30"
			src="/favicon.ico"
			alt="Loading ..."
		/>
	);
}
